import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FaIconComponent } from '@akostm/orbit-ui';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'shared-message-text',
  standalone: true,
  imports: [CommonModule, FaIconComponent],
  templateUrl: './message-text.component.html',
  styleUrl: './message-text.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageTextComponent {
  messageText = input.required<string>();
  link = input<boolean>(false);
  readonly openLinkIcon = faArrowUpRightFromSquare;
}
